// Dependencies
import React, { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Row, Col, Spinner } from 'react-bootstrap';
import { useSelector, useDispatch } from "react-redux";
import { actions as actionTypePay } from "../../../reducers/TypePayment";
import { actions as actionStep } from "../../../reducers/Step";
import axios from 'axios';
import FAMSA from '../../../config/constants';
import { Alert } from '../../Alerts';
import BannerCarousel from './bannercarousel';
import BannerCard from './bannercard';
import { getLang } from '../../../reducers/lang';

const Principal = () => {
    const distpatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [images, setImages] = useState([]);
    const [imagesEs, setImagesEs] = useState([]);
    const isDesktopOrLaptop = useMediaQuery({query: '(min-width: 1224px)'})
    const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
    const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })
    const sLang = useSelector(getLang);

    const handleBtn = (event, type) => {
        event.preventDefault();
        distpatch(actionStep.setPage(0));
        distpatch(actionTypePay.setTypePay(type));
    }

    const getBanner = async () => {
        setLoading(true);
        const params = {
            "districtId": "51",
            "carouselType": 2
        };
        const fullURL = FAMSA.SERVER.SERVER_BANNER + "/api/DealList";

        await axios.post(fullURL, params).then((response) => {
            setLoading(false);
            if (response !== undefined) {
                if (response.status === 200) {
                    let auximg = [];
                    let auximgEs = [];
                    response.data.map((value, index) => {
                        //console.log("value: ", value);
                        //auximg.push(value[0].CarouselPath + (sLang == 'en-US'? value[0].CarouselImgNameEn : value[0].CarouselImgNameEs));
                        auximg.push(value[0].CarouselPath + value[0].CarouselImgNameEn);
                        auximgEs.push(value[0].CarouselPath + value[0].CarouselImgNameEs);
                    });
                    setImages(auximg);
                    setImagesEs(auximgEs);

                    console.log("images: ", auximg);
                }
            } else {
                Alert("danger", "Error", "Sorry, there is an inconvenience with the information, \nplease report it to IT Support, Thanks.");
            }
        }).catch(error => {
            setLoading(false);
            Alert("danger", "Error", "Sorry, there is an inconvenience with the information, \nplease report it to IT Support, Thanks.");
        });
    }

    useEffect(() => {
        getBanner();
    }, []);

    return (
        <>
            {(loading) ?
                <>
                    <Row className='justify-content-center mx-3 my-3'>
                        <Col md={{ span: 6, offset: 5 }}>
                            <Spinner
                                as="span"
                                animation="border"
                                size="xl"
                                role="status"
                                aria-hidden="true"
                            />
                        </Col>
                    </Row>
                </> :
                <>
                {isDesktopOrLaptop && <Row className={`justify-content-center famsa-carousel ${(!loading) ? (images.length === 0) ? "famsa-backgorund-banner" : "" : ""}`}><BannerCarousel images={sLang == 'en-US' ? images: imagesEs} handleBtn={handleBtn} /></Row>}
                {isTabletOrMobile  && <Row className={`justify-content-center famsa-carousel ${(!loading) ? (images.length === 0) ? "famsa-backgorund-banner" : "famsa-backgorund-banner" : ""}`}><Col md={{ span: (isPortrait) ? 7 : 6}} className='my-3'><BannerCard handleBtn={handleBtn}/></Col></Row>}
                </>
            }
        </>
    );
}

export default Principal;